// Validação de CPF e CNPJ — inclui o CNPJ alfanumérico (Anexo XV da IN RFB
// nº 2.119/2022): 12 primeiras posições alfanuméricas + 2 dígitos
// verificadores numéricos, calculados pelo mesmo algoritmo Módulo 11 do CNPJ
// numérico legado (cada caractere vale seu código ASCII - 48). Espelha
// appointments-backend/src/utils/documentValidation.js.

function calcCheckDigit(base) {
  const n = base.length
  let sum = 0
  for (let i = 0; i < n; i++) {
    const weight = ((n - 1 - i) % 8) + 2
    sum += (base.charCodeAt(i) - 48) * weight
  }
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

export function isValidCnpj(value) {
  const clean = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (!/^[A-Z0-9]{12}\d{2}$/.test(clean)) return false

  const base = clean.slice(0, 12)
  const dv1 = calcCheckDigit(base)
  if (dv1 !== Number(clean[12])) return false

  const dv2 = calcCheckDigit(base + dv1)
  if (dv2 !== Number(clean[13])) return false

  return true
}

export function isValidCpf(value) {
  const digits = String(value || '').replace(/\D/g, '')
  if (!/^\d{11}$/.test(digits)) return false
  if (/^(\d)\1{10}$/.test(digits)) return false

  let sum = 0
  for (let i = 0; i < 9; i++) sum += Number(digits[i]) * (10 - i)
  let dv1 = 11 - (sum % 11)
  if (dv1 >= 10) dv1 = 0
  if (dv1 !== Number(digits[9])) return false

  sum = 0
  for (let i = 0; i < 10; i++) sum += Number(digits[i]) * (11 - i)
  let dv2 = 11 - (sum % 11)
  if (dv2 >= 10) dv2 = 0
  if (dv2 !== Number(digits[10])) return false

  return true
}

export function isValidCpfOrCnpj(value) {
  const alnum = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (/^\d{11}$/.test(alnum)) return isValidCpf(alnum)
  if (alnum.length === 14) return isValidCnpj(alnum)
  return false
}
